/* global jQuery, themeVariables */
import jQuery from 'jquery';
// import Ps from 'perfect-scrollbar';
// import Select2 from 'select2';

// Relative Imports
import Header from './modules/header';
import Filters from './modules/filters';
import HighlightToTweet from './modules/highlight-to-tweet';
import SocialSharing from './modules/social-sharing';
import FadeAnimation from "./modules/fade-animation";

(function ($) {
    const debug = true;
    const mobileBreakpoint = 747;

    // In functions-config.php we are passing `themeVariables` to push PHP
    // values to JS console.log(themeVariables);


    /**
     * Header
     */
    new Header('.js-header');

    /**
     * Map
     */
    new FadeAnimation;

    /**
     * Filters
     */
    new Filters('.js-filters');

    /**
     * Highlight To Tweet
     */
    new HighlightToTweet(themeVariables);

    /**
     * Social sharing
     */
    new SocialSharing('.js-social-share', '.js-webshare');

    // Select2 Example
    // new Select2();
    //
    // $('.js-sorter').select2({
    //     minimumResultsForSearch: -1,
    //     width: '100%'
    // });

    // Perfect Scrollbar Example
    // addScrollbars () {
    //     for (let i = 0; i < this.$filterLists.length; i++) {
    //         this.scrollbars.push(new Ps(this.$filterLists[i]));
    //     }
    // }
    //
    // updateScrollbars () {
    //     this.scrollbars.forEach((ps) => ps.update());
    // }

}(jQuery));
